import * as yup from 'yup';

export const recorbAppDownloadSchema = yup.object().shape({
  serialNumber: yup.string().required('Serial number is required'),
  hardwareSignature: yup.string().required('Hardware Signature is required'),
  agentName: yup.string().optional(),
  agencyEmail: yup.string().optional(),
});
